import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useSelector as rawUseSelector } from 'react-redux';

import { getCurrentLanguage } from '@/i18n';

type GlobalState = {
  volatile: {
    loginUser?: any;
  };
  persistent: {
    language: string;
  };
};

const initialState: GlobalState = {
  volatile: {},
  persistent: {
    language: getCurrentLanguage(),
  },
};

const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    setLanguage(state, action: PayloadAction<string>) {
      state.persistent.language = action.payload;
    },
  },
});

export const store = configureStore({
  reducer: {
    main: mainSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useSelector = rawUseSelector;
export const actions = mainSlice.actions;
